import React, { useEffect } from 'react';

const ThankYouPage = () => {
  useEffect(() => {
    // Meta Pixel Code - Lead Event
    (function(f,b,e,v,n,t,s) {
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=true;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=true;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s);
    })(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    
    window.fbq('init', '1247687080588842');
    window.fbq('track', 'Lead');
    window.fbq('track', 'PageView');
  }, []);

  return (
    <>
      {/* Noscript fallback for Facebook Pixel */}
      <noscript>
        <img 
          height="1" 
          width="1" 
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=1247687080588842&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>

      <div style={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Open Sans', sans-serif",
        direction: 'rtl',
        padding: '20px'
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '600px'
        }}>
          <div style={{
            marginBottom: '24px'
          }}>
            <svg 
              width="80" 
              height="80" 
              viewBox="0 0 80 80" 
              fill="none" 
              style={{ margin: '0 auto' }}
            >
              <circle 
                cx="40" 
                cy="40" 
                r="38" 
                stroke="#5D4E37" 
                strokeWidth="3"
                fill="none"
              />
              <path 
                d="M25 40L35 50L55 30" 
                stroke="#5D4E37" 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
          
          <h1 style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#5D4E37',
            marginBottom: '16px',
            lineHeight: '1.4'
          }}>
            הפרטים התקבלו בהצלחה
          </h1>
          
          <p style={{
            fontSize: '20px',
            fontWeight: '400',
            color: '#5D4E37',
            lineHeight: '1.6'
          }}>
            אצור איתך קשר בהקדם
          </p>
        </div>
      </div>
    </>
  );
};

export default ThankYouPage;